// Brookline Governing Documents Database
// Version 1.4
// Updated October 13, 2026
//
// `dateAdopted` holds the date of the governing action (YYYY-MM-DD / YYYY-MM / YYYY).
// `dateAction` names that action and is optional — it defaults to "Adopted" when
// absent. Set it explicitly where the act was something else, e.g. "Accepted"
// (a body receiving/acknowledging a study or report rather than adopting it as
// binding policy). The detail page labels the date "Date <dateAction>".

// Shown at the top of the list page. Keep in step with the header comment above.
export const governingDocsVersion = "Version 1.4";
export const governingDocsUpdated = "October 13, 2026";

export const governingDocsData = [
  {
    id: "2030-roadmap",
    name: "2030 Roadmap",
    websiteUrl: "https://www.brooklinema.gov/4102/2030-Roadmap",
    documentUrl: null,
    authorizingBody: "Select Board",
    dateAdopted: "2026-05-19",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "5-year-paving-plan",
    name: "5-year Paving Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62510",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "affirmative-action-policy",
    name: "Affirmative Action Policy (EEO-4)",
    websiteUrl: "https://www.brooklinema.gov/1526/Affirmative-Action-Policy-EE0-4",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2016-12-13",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "affordable-housing-standards-and-guidelines",
    name: "Affordable Housing Standards and Guidelines",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/52938/Affordable-Housing-Standards-and-Guidelines-Approved-September-2024",
    authorizingBody: null,
    dateAdopted: "2024-09",
    tags: [{label: "Type", value: "Guidelines"}, {label: "Department", value: "Planning"}, {label: "Public Body", value: "Housing Advisory Board"}, {label: "Public Body", value: "Planning Board"}],
    notes: "",
  },
  {
    id: "americans-with-disabilities-act",
    name: "Americans with Disabilities Act (ADA)",
    websiteUrl: "https://www.brooklinema.gov/560/Americans-With-Disabilities-Act-ADA",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}, {label: "Public Body", value: "Brookline Commission on Disability"}, {label: "Public Body", value: "Commission for Diversity, Equity, Inclusion & Community Relations"}],
    notes: "",
  },
  {
    id: "anti-retaliation-policy",
    name: "Anti-Retaliation Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/347/Anti-Retaliation-Policy-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "athletic-fields-needs-assessment-and-master-plan",
    name: "Athletic Fields Needs Assessment and Master Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/23572/Fields-Assessment-2020",
    authorizingBody: null,
    dateAdopted: "2020-11",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Department", value: "Recreation"}],
    notes: "",
  },
  {
    id: "backwater-valve-policy",
    name: "Backwater Valve Policy",
    websiteUrl: "https://www.brooklinema.gov/3896/Backwater-Valve-Policy",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Water & Sewer"}],
    notes: "",
  },
  {
    id: "behavior-policy",
    name: "Behavior Policy - Senior Center",
    websiteUrl: "https://www.brooklinema.gov/2362/Policies",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/33651/Behavior-Policy-",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Council on Aging"}],
    notes: "",
  },
  {
    id: "biosafety-regulations",
    name: "Biosafety Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/49172/Regulations-for-Town-of-Brookline-Revision-Regs-Final",
    authorizingBody: null,
    dateAdopted: "2024-04-01",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "boards-and-commissions-email-record-retention-policy",
    name: "Boards and Commissions Email Record Retention Policy",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/874/files/attachment/209",
    authorizingBody: "Select Board",
    dateAdopted: "2024-07-09",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "boards-and-commissions-event-co-sponsorship-policy",
    name: "Boards and Commissions Event Co-Sponsorship Policy",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/884/files/attachment/1228",
    authorizingBody: "Select Board",
    dateAdopted: "2024-09-17",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "body-art-establishments-regulations",
    name: "Body Art Establishments Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/7752/Regulations-Governing-Body-Art-Establishments",
    authorizingBody: null,
    dateAdopted: "2022-10-17",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "bridle-path-feasibility-study",
    name: "Bridle Path Feasibility Study",
    websiteUrl: "https://www.brooklinema.gov/3542/Beacon-Street-Historic-Bridle-Path-Recon",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/38281/BrooklineBridlePath_FeasibilityStudyReport_FINAL",
    authorizingBody: null,
    dateAdopted: "2023",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "brookline-hazardous-materials-emergency-plan",
    name: "Brookline Hazardous Materials Emergency Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/52615",
    authorizingBody: null,
    dateAdopted: "2025-10",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Emergency Management"}],
    notes: "",
  },
  {
    id: "brookline-older-adult-community-health-needs-assessment",
    name: "Brookline Older Adult Community Health Needs Assessment",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/32698/FINAL-REPORT-Brookline-Older-Adult-Community-Health-Needs-Assessment-2022",
    authorizingBody: null,
    dateAdopted: "2022",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Council on Aging"}],
    notes: "",
  },
  {
    id: "brookline-village-parking-and-curb-use-study",
    name: "Brookline Village Parking and Curb Use Study",
    websiteUrl: "https://www.brooklinema.gov/3940/Brookline-Village-Parking-and-Curb-Use-S",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/63110",
    authorizingBody: null,
    dateAdopted: "2026-07-28",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "browser-compatibility-policy",
    name: "Browser Compatibility Policy",
    websiteUrl: "https://www.brooklinema.gov/432/Browser-Compatibility",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "cancellations-policy",
    name: "Cancellations Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_1",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "cemetery-rules-and-regulations",
    name: "Cemetery Rules & Regulations",
    websiteUrl: "https://www.brooklinema.gov/551/Cemetery-Rules-Regulations",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}],
    notes: "",
  },
  {
    id: "cip-policies",
    name: "CIP Policies",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/5523/CIP-Policies---Final-PDF",
    authorizingBody: null,
    dateAdopted: "2025-04-23",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Finance"}],
    notes: "",
  },
  {
    id: "civil-immigration-enforcement-proclamation",
    name: "Civil Immigration Enforcement Proclamation",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/14767/files/attachment/10883",
    authorizingBody: "Select Board",
    dateAdopted: "2026-02-10",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "climate-action-and-resiliency-plan",
    name: "Climate Action and Resiliency Plan",
    websiteUrl: "https://www.brooklinema.gov/3907/2025-Climate-Action-and-Resiliency-Plan",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62895/Brookline-Climate-Action--Resiliency-Plan-2026",
    authorizingBody: "Select Board",
    dateAdopted: "2026",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Sustainability & Natural Resources"}, {label: "Public Body", value: "Zero Emissions Advisory Board"}],
    notes: "",
  },
  {
    id: "net-zero-carbon-emissions-goal",
    name: "Climate Emergency Declaration and Climate Crisis Action Plan Adoption",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/24610/Combined-Reports-May-2021-Annual-Town-Meeting-with-supplements",
    authorizingBody: "Town Meeting",
    dateAdopted: "2021-05",
    tags: [{label: "Authorizing Body", value: "Town Meeting"}, {label: "Goal", value: "Net Zero Carbon Emissions Goal"}, {label: "Town Meeting", value: "2021 ATM"}, {label: "Public Body", value: "Zero Emissions Advisory Board"}, {label: "Department", value: "Town Meeting"}],
    notes: "",
  },
  {
    id: "cobra-policy",
    name: "COBRA Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8177/COBRA-Policy-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "commissions-committees-and-boards-demographic-report",
    name: "Commissions, Committees and Boards Demographic Report",
    websiteUrl: "https://www.brooklinema.gov/2326/Data-Reports-Central",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/52016/FINAL-CCB-Demographic-Report-2024-v3?bidId=",
    authorizingBody: null,
    dateAdopted: "2024",
    tags: [{label: "Type", value: "Report"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "communication-requests-and-reasonable-accommodations",
    name: "Communication Requests and Reasonable Accommodations",
    websiteUrl: "https://www.brooklinema.gov/560/Americans-With-Disabilities-Act-ADA",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/18327",
    authorizingBody: null,
    dateAdopted: "2018-12-18",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}, {label: "Public Body", value: "Commission for Diversity, Equity, Inclusion & Community Relations"}],
    notes: "",
  },
  {
    id: "community-health-assessment",
    name: "Community Health Assessment",
    websiteUrl: "https://www.brooklinema.gov/3632/Community-Health-Assessment-Improvement-",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/54183/Brookline-CHA-Report-Final-Aug2024_new-cover",
    authorizingBody: null,
    dateAdopted: "2024-08",
    tags: [{label: "Type", value: "Report"}, {label: "Department", value: "Public Health"}, {label: "Public Body", value: "Advisory Council on Public Health"}],
    notes: "",
  },
  {
    id: "community-health-improvement-plan",
    name: "Community Health Improvement Plan",
    websiteUrl: "https://www.brooklinema.gov/3632/Community-Health-Assessment-Improvement-",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/54247/Brookline-CHIP-Report-22025",
    authorizingBody: null,
    dateAdopted: "2025-01",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Health"}],
    notes: "",
  },
  {
    id: "complete-streets-policy",
    name: "Complete Streets Policy",
    websiteUrl: "https://www.brooklinema.gov/3614/Complete-Streets",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62016",
    authorizingBody: "Select Board",
    dateAdopted: "2025-03-25",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "comprehensive-emergency-management-plan",
    name: "Comprehensive Emergency Management Plan",
    websiteUrl: "https://www.brooklinema.gov/3979/Comprehensive-Emergency-Management-Plan",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/59525",
    authorizingBody: "Select Board",
    dateAdopted: "2025-07-01",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Emergency Management"}],
    notes: "",
  },
  {
    id: "comprehensive-plan",
    name: "Comprehensive Plan",
    websiteUrl: "https://www.brooklinema.gov/242/Brookline-Comprehensive-Plan",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Planning"}, {label: "Public Body", value: "Planning Board"}],
    notes: "",
  },
  {
    id: "concussion-policy-for-youth",
    name: "Concussion Policy for Youth",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_3",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "conservation-area-rules-and-regulations",
    name: "Conservation Area Rules and Regulations",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/2045/Conservation-Area-Rules-and-Regulations",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "construction-management-program-guidelines",
    name: "Construction Management Program Guidelines",
    websiteUrl: "https://www.brooklinema.gov/2496/Construction-Management-Transportation-A",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/35885/Construction-Management-Program-Guidelines",
    authorizingBody: null,
    dateAdopted: "2018-03",
    tags: [{label: "Type", value: "Guidelines"}, {label: "Department", value: "Public Works"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "article-4-3-3-prohibition-of-sales",
    name: "Contracts: Prohibited Action",
    websiteUrl: null,
    documentUrl: null,
    authorizingBody: "Town Meeting",
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Human Resources"}, {label: "Article", value: "4.3", url: "https://ecode360.com/41145012"}],
    notes: "",
  },
  {
    id: "coolidge-corner-and-jfk-crossing-rapid-recovery-plan",
    name: "Coolidge Corner and JFK Crossing Rapid Recovery Plan",
    websiteUrl: "https://www.brooklinema.gov/1971/Local-Rapid-Recovery-Plan-Coolidge-Corne",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2021",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Planning"}],
    notes: "",
  },
  {
    id: "coolidge-corner-parking-and-curb-use-study",
    name: "Coolidge Corner Parking and Curb Use Study",
    websiteUrl: "https://www.brooklinema.gov/3816/Coolidge-Corner-Parking-and-Curb-Use-Stu",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/54428/Coolidge-Corner-Parking-Study-Final-Report",
    authorizingBody: null,
    dateAdopted: "2025-03",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "cori-policy",
    name: "CORI Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/346/CORI-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2012-10",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "delegation-of-authority-to-issue-declarations-of-emergency",
    name: "Delegation of Authority to Issue Declarations of Emergency",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/57696/Policy-delegating-authority-emergency---April-2025",
    authorizingBody: "Select Board",
    dateAdopted: "2025-04-29",
    tags: [{label: "Type", value: "Policy"}, {label: "Authorizing Body", value: "Select Board"}, {label: "Department", value: "Emergency Management"}],
    notes: "",
  },
  {
    id: "disclaimer-policy",
    name: "Disclaimer Policy",
    websiteUrl: "https://www.brooklinema.gov/433/Disclaimer",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "disparity-study",
    name: "Disparity Report",
    websiteUrl: "https://www.brooklinema.gov/1898/Disparity-Report",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2022-03",
    tags: [{label: "Type", value: "Report"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "diversity-equity-inclusion-and-community-relations-policies",
    name: "Diversity, Equity, Inclusion and Community Relations Policies",
    websiteUrl: "https://www.brooklinema.gov/2327/Policies",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "dpw-strategic-plan",
    name: "DPW Strategic Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/44852/Strategic-Plan-DPW-Spreads_FinalUpdate2023",
    authorizingBody: null,
    dateAdopted: "2022",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}],
    notes: "",
  },
  {
    id: "drug-and-alcohol-testing-policy",
    name: "Drug and Alcohol Testing Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8173/Drug-and-Alcohol-Testing-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "1995-01-01",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "drug-free-workplace-policy",
    name: "Drug Free Workplace Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/20370/Drug-Free-Workplace-Policy",
    authorizingBody: null,
    dateAdopted: "2017-09",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "emergency-protocol",
    name: "Emergency Protocol - Senior Center",
    websiteUrl: "https://www.brooklinema.gov/2362/Policies",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/33849/Emergency-Protocol-",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Council on Aging"}],
    notes: "",
  },
  {
    id: "environmentally-preferable-product-policy",
    name: "Environmentally Preferable Products Purchasing Policy",
    websiteUrl: "https://www.brooklinema.gov/4031/Environmentally-Preferable-Product-Polic",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/60519",
    authorizingBody: "Select Board",
    dateAdopted: "2026-04-28",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Finance"}, {label: "Division", value: "Purchasing"}],
    notes: "",
  },
  {
    id: "equal-employment-opportunity-policy",
    name: "Equal Employment Opportunity Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/12276/Equal-Employment-Opportunity-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2016-12-13",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "ethics-conflict-of-interest-summary",
    name: "Ethics/Conflict of Interest Summary",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8171/EthicsConflict-of-Interest-Summary-PDF",
    authorizingBody: null,
    dateAdopted: "2016-11-14",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "exigent-statement-ratification-policy",
    name: "Exigent Statement Ratification Policy",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/16245/files/attachment/18267",
    authorizingBody: "Select Board",
    dateAdopted: "2026-08-11",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "expenditures-and-revenues-study-committee-final-report",
    name: "Expenditures and Revenues Study Committee Final Report",
    websiteUrl: "https://www.brooklinema.gov/3899/Expenditures-Revenues-Study-Committee",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/61986/ERSC-Final-Report",
    authorizingBody: null,
    dateAdopted: "2026-03-13",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "expressive-outdoor-fixtures-policy",
    name: "Expressive Outdoor Fixtures Policy",
    websiteUrl: "https://www.brooklinema.gov/343/Select-Board",
    documentUrl: null,
    authorizingBody: "Select Board",
    dateAdopted: "2023-12-05",
    tags: [{label: "Type", value: "Policy"}, {label: "Public Body", value: "Select Board"}],
    notes: "",
  },
  {
    id: "ffys-2025-2030-consolidated-plan-and-ffy-2025-cdbg-annual-action-plan",
    name: "FFYs 2025-2030 (FYs 2026-2030) Consolidated Plan and FFY 2025 (FY 2026) CDBG Annual Action Plan",
    websiteUrl: "https://www.brooklinema.gov/2365/Community-Planning-Documents",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/57780/FY-26---FY-30-Consolidated-Plan-and-FY-26-AAP-Final",
    authorizingBody: "Select Board",
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Planning"}, {label: "Public Body", value: "CDBG Advisory Committee"}],
    notes: "",
  },
  {
    id: "filming-on-town-property-policy",
    name: "Filming on Town Property Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_4",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "financial-aid-policy",
    name: "Financial Aid Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_5",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "flag-policy",
    name: "Flag Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8178/American-Flag-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2012-09-25",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "fleet-management-electrification-and-vehicle-replacement-policy",
    name: "Fleet Management, Electrification and Vehicle Replacement Policy",
    websiteUrl: "https://www.brooklinema.gov/4061/Municipal-Fleet-Electrification",
    documentUrl: null,
    authorizingBody: "Select Board",
    dateAdopted: "2025-12-16",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Sustainability & Natural Resources"}],
    notes: "",
  },
  {
    id: "food-establishments-chapter-x-regulations",
    name: "Food Establishments, Chapter X Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1077",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "free-cash-policy",
    name: "Free Cash Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/5524/Free-Cash-Policy---Final-PDF",
    authorizingBody: null,
    dateAdopted: "2025-04-23",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Finance"}],
    notes: "",
  },
  {
    id: "general-by-laws",
    name: "General By-Laws",
    websiteUrl: "https://ecode360.com/BR2945",
    documentUrl: null,
    authorizingBody: "Town Meeting",
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Town Meeting"}],
    notes: "",
  },
  {
    id: "generative-ai-use-policy",
    name: "Generative AI Use Policy",
    websiteUrl: "https://www.brooklinema.gov/3975/Generative-AI-Use",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08-19",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "green-dog-rules-and-regulations",
    name: "Green Dog Rules & Regulations",
    websiteUrl: "https://www.brooklinema.gov/1571/Rules-and-Regulations-Signage",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}],
    notes: "",
  },
  {
    id: "green-routes-bicycle-network-plan",
    name: "Green Routes Bicycle Network Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/40258/BrooklineGreenRoutes2023?bidId=",
    authorizingBody: null,
    dateAdopted: "2023-03",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}, {label: "Public Body", value: "Bicycle Advisory Committee"}],
    notes: "",
  },
  {
    id: "grievance-procedure",
    name: "Grievance Procedure",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/14114",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}, {label: "Public Body", value: "Commission for Diversity, Equity, Inclusion & Community Relations"}],
    notes: "",
  },
  {
    id: "ground-floor-commercial-incentive-standards-and-guidelines-for-mixed-use-districts-outside-of-harvard-street",
    name: "Ground Floor Commercial Incentive Standards and Guidelines for Mixed-Use Districts Outside of Harvard Street",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/907/files/attachment/3942",
    authorizingBody: "Select Board",
    dateAdopted: "2025-02-25",
    tags: [{label: "Type", value: "Guidelines"}, {label: "Department", value: "Planning"}, {label: "Public Body", value: "Economic Development Advisory Board"}],
    notes: "",
  },
  {
    id: "hazard-mitigation-plan",
    name: "Hazard Mitigation Plan",
    websiteUrl: "https://www.brooklinema.gov/3532/Hazard-Mitigation-Plan-2023-Update",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/47541/Brookline-Mitigation-Plan-2023---FEMA-Approved-11-28-2023",
    authorizingBody: null,
    dateAdopted: "2023",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Emergency Management"}],
    notes: "",
  },
  {
    id: "housing-production-plan",
    name: "Housing Production Plan",
    websiteUrl: "https://www.brooklinema.gov/1299/Housing-Production-Plan",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/53784/BHHP2024-11-12---approved-by-state",
    authorizingBody: null,
    dateAdopted: "2024-02",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Planning"}, {label: "Public Body", value: "Housing Advisory Board"}, {label: "Public Body", value: "Planning Board"}],
    notes: "",
  },
  {
    id: "housing-chapter-ii-regulations",
    name: "Housing, Chapter II Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1082",
    authorizingBody: null,
    dateAdopted: "2007-01-26",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "article-3-15-human-resources-program",
    name: "Human Resources Program, Board and Office",
    websiteUrl: null,
    documentUrl: null,
    authorizingBody: "Town Meeting",
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Human Resources"}, {label: "Article", value: "3.15", url: "https://ecode360.com/41144919"}],
    notes: "",
  },
  {
    id: "immigration-and-refugee-policy",
    name: "Immigration and Refugee Policy",
    websiteUrl: "https://www.brooklinema.gov/1411/Immigration-and-Refugee-Policy",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2017-04-25",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "inappropriate-use-policy",
    name: "Inappropriate Use Policy",
    websiteUrl: "https://www.brooklinema.gov/435/Inappropriate-Use",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "inclement-weather-policy",
    name: "Inclement Weather Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_7",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "information-technology-policies",
    name: "Information Technology Policies",
    websiteUrl: "https://www.brooklinema.gov/280/IT-Policies",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "injury-incident-reporting-policy",
    name: "Injury Incident Reporting Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_8",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "internet-fraud-policy",
    name: "Internet Fraud Policy",
    websiteUrl: "https://www.brooklinema.gov/437/Internet-Fraud",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "investment-policy",
    name: "Investment Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/18638/Investment-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2019-01-29",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Finance"}],
    notes: "",
  },
  {
    id: "it-resource-use-policy",
    name: "IT Resource Use Policy",
    websiteUrl: "https://www.brooklinema.gov/421/IT-Resource-Use",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08-19",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "language-access-policy",
    name: "Language Access Policy",
    websiteUrl: "https://www.brooklinema.gov/3897/Language-Access",
    documentUrl: null,
    authorizingBody: "Select Board",
    dateAdopted: "2025-01-14",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "linking-to-from-this-site-policy",
    name: "Linking To/From This Site Policy",
    websiteUrl: "https://www.brooklinema.gov/438/Linking-tofrom-this-Site",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "article-4-8-living-wage-by-law",
    name: "Living Wage By-law",
    websiteUrl: "https://www.brooklinema.gov/999/Living-Wage-By-Law",
    documentUrl: null,
    authorizingBody: "Town Meeting",
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Human Resources"}, {label: "Article", value: "4.8", url: "https://ecode360.com/41146431"}],
    notes: "",
  },
  {
    id: "lodging-houses-regulations",
    name: "Lodging Houses Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1078",
    authorizingBody: null,
    dateAdopted: "1999-05-12",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "lost-and-found-policy",
    name: "Lost & Found Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_9",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "media-engagement-policy",
    name: "Media Engagement Policy",
    websiteUrl: "https://www.brooklinema.gov/297/Other-Policies-By-Laws#tabc9ae9434-9ad4-4455-b3f8-093b453a85f5_3",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/59495",
    authorizingBody: null,
    dateAdopted: "2025-07",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "medication-administration-policy",
    name: "Medication Administration Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_10",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "miscellaneous-human-resources-policies",
    name: "Miscellaneous Human Resources Policies",
    websiteUrl: "https://www.brooklinema.gov/297/Other-Policies-By-Laws",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "noise-bylaw",
    name: "Noise By-law",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1076",
    authorizingBody: null,
    dateAdopted: "2008-11-18",
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}, {label: "Article", value: "8.15", url: "https://ecode360.com/41145803"}],
    notes: "",
  },
  {
    id: "open-space-and-recreation-plan",
    name: "Open Space and Recreation Plan",
    websiteUrl: "https://www.brooklinema.gov/664/Open-Space-and-Recreation-Plan",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/60517/Open-Space-and-Recreation-Plan-2025---FINAL?bidId=",
    authorizingBody: null,
    dateAdopted: "2025",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Department", value: "Recreation"}],
    notes: "",
  },
  {
    id: "outdoor-dining-program-regulations-and-guidelines",
    name: "Outdoor Dining Program Regulations and Guidelines",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/886/files/attachment/1460",
    authorizingBody: "Select Board",
    dateAdopted: "2024-10-01",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "outstanding-balance-policy",
    name: "Outstanding Balance Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_12",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "paid-parental-leave-policy",
    name: "Paid Parental Leave Policy",
    websiteUrl: "https://www.brooklinema.gov/297/Other-Policies-By-Laws#tabc9ae9434-9ad4-4455-b3f8-093b453a85f5_5",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8336/Parental-Leave-Law-2015-PDF",
    authorizingBody: null,
    dateAdopted: "2023-07-01",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "park-rules-and-regulations",
    name: "Park Rules and Regulations",
    websiteUrl: "https://www.brooklinema.gov/1312/Park-Rules-and-Regulations",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2015-06-16",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}],
    notes: "",
  },
  {
    id: "parks-open-space-and-recreation-strategic-master-plan",
    name: "Parks, Open Space and Recreation 2020 Strategic Master Plan Update",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/23568/Parks-Open-Space-and-Recreation-Strategic-Master-Plan-2020",
    authorizingBody: null,
    dateAdopted: "2020-09",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "pedestrian-walk-signals-study",
    name: "Pedestrian Walk Signals Study",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62025",
    authorizingBody: null,
    dateAdopted: "2019-10",
    dateAction: "Accepted",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Pedestrian Advisory Committee"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "perspectives-and-opportunities-for-commercial-area",
    name: "Perspectives and Opportunities for Brookline's Commercial Area",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/14021/FINAL-REPORT_33018",
    authorizingBody: null,
    dateAdopted: "2018-03",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Planning"}, {label: "Public Body", value: "Economic Development Advisory Board"}],
    notes: "",
  },
  {
    id: "photo-policy",
    name: "Photo Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_13",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "police-policy-and-procedures",
    name: "Police Policy and Procedures",
    websiteUrl: "https://www.brooklinepolice.com/185/Brookline-Police-Policies-and-Procedures",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Police"}],
    notes: "",
  },
  {
    id: "policy-against-discrimination-sexual-harassment-and-retaliation",
    name: "Policy Against Discrimination, Sexual Harassment and Retaliation",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/10320/Policy-Against-Discrimination-Sexual-Harassment-and-Retaliation-PDF",
    authorizingBody: null,
    dateAdopted: "2024-12",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "policy-against-fraudulent-conduct",
    name: "Policy Against Fraudulent Conduct",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/343/Policy-Against-Fraudulent-Conduct-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "policy-and-procedures-for-allocation-of-baa-waivers-to-town-of-brookline-employees",
    name: "Policy and Procedures for Allocation of BAA Waivers to Town of Brookline Employees",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/890/files/attachment/2046",
    authorizingBody: "Select Board",
    dateAdopted: "2024-10-29",
    tags: [{label: "Type", value: "Policy"}],
    notes: "",
  },
  {
    id: "privacy-policy",
    name: "Privacy Policy",
    websiteUrl: "https://www.brooklinema.gov/439/Privacy",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "public-art-guidelines-for-parks-and-open-spaces",
    name: "Public Art Guidelines for Parks and Open Spaces",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/2840/Brookline-Public-Art-Guidelines?bidId=",
    authorizingBody: null,
    dateAdopted: "2011-04-12",
    tags: [{label: "Type", value: "Guidelines"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "public-comment-policy-advisory-council-on-public-health",
    name: "Public Comment Policy - Advisory Council on Public Health",
    websiteUrl: "https://www.brooklinema.gov/653/Advisory-Council-of-Public-Health",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/46984",
    authorizingBody: "Advisory Council on Public Health",
    dateAdopted: "2023-12-20",
    tags: [{label: "Type", value: "Policy"}, {label: "Public Body", value: "Advisory Council on Public Health"}],
    notes: "",
  },
  {
    id: "public-comment-policy-brookline-commission-for-women",
    name: "Public Comment Policy - Brookline Commission for Women",
    websiteUrl: "https://www.brooklinema.gov/729/Brookline-Commission-for-Women",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/48453",
    authorizingBody: "Brookline Commission for Women",
    dateAdopted: "2024-02-28",
    tags: [{label: "Type", value: "Policy"}, {label: "Public Body", value: "Brookline Commission for Women"}],
    notes: "",
  },
  {
    id: "public-comment-policy-brookline-commission-on-disability",
    name: "Public Comment Policy - Brookline Commission on Disability",
    websiteUrl: "https://www.brooklinema.gov/bcod",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/46352/BCOD-Public-Comment-Policy---11082023",
    authorizingBody: "Brookline Commission on Disability",
    dateAdopted: "2023-11-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Public Body", value: "Brookline Commission on Disability"}],
    notes: "One five-minute public comment period near the start of each meeting, two minutes per speaker. The full text is on the commission's page under the \"Public Comment Policy\" tab.",
  },
  {
    id: "public-comment-policy-police-commissioners-advisory-committee",
    name: "Public Comment Policy - Police Commissioners Advisory Committee",
    websiteUrl: "https://www.brooklinema.gov/pcac",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/47789",
    authorizingBody: "Police Commissioners Advisory Committee",
    dateAdopted: "2024-01-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Public Body", value: "Police Commissioners Advisory Committee"}],
    notes: "",
  },
  {
    id: "public-comments-policy",
    name: "Public Comment Policy - Select Board",
    websiteUrl: "https://www.brooklinema.gov/343/Select-Board",
    documentUrl: null,
    authorizingBody: "Select Board",
    dateAdopted: "2023-11-07",
    tags: [{label: "Type", value: "Policy"}, {label: "Public Body", value: "Select Board"}],
    notes: "",
  },
  {
    id: "article-4-6-public-relations-and-information",
    name: "Public Relations and Information",
    websiteUrl: null,
    documentUrl: null,
    authorizingBody: "Town Meeting",
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Human Resources"}, {label: "Article", value: "4.6", url: "https://ecode360.com/41146425"}],
    notes: "",
  },
  {
    id: "recreation-camps-regulations",
    name: "Recreation Camps Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1086",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "recreation-code-of-conduct",
    name: "Recreation Code of Conduct",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_2",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "recreation-department-policies-and-procedures",
    name: "Recreation Department Policies and Procedures",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_3",
    documentUrl: "https://www.brooklinerec.com/DocumentCenter/View/6546",
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "refunds-and-no-shows-policy",
    name: "Refunds & No-shows Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_15",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "reserve-policy",
    name: "Reserve Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/5525/Reserve-Policies---Final-PDF",
    authorizingBody: null,
    dateAdopted: "2025-04-23",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Finance"}],
    notes: "",
  },
  {
    id: "resident-and-non-resident-registration-and-fee-allocation-policy",
    name: "Resident & Non-Resident Registration & Fee Allocation Policy",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_16",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "roadway-asset-management-maintenance-and-preservation-policy",
    name: "Roadway Asset Management, Maintenance and Preservation Policy",
    websiteUrl: "https://www.brooklinema.gov/3908/Brookline-Pavement-Maintenance-and-Prese",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62033/PMPP-Policy?bidId=",
    authorizingBody: "Select Board",
    dateAdopted: "2025-03-25",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "security-policy",
    name: "Security Policy",
    websiteUrl: "https://www.brooklinema.gov/440/Security",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "select-board-fy26-goals-and-objectives",
    name: "Select Board FY26 Goals and Objectives",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/53082/Select-Board-FY26-Goals-and-Objectives?bidId=",
    authorizingBody: "Select Board",
    dateAdopted: "2024-09-17",
    tags: [{label: "Type", value: "Plan"}, {label: "Authorizing Body", value: "Select Board"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "select-board-fy27-goals-and-objectives",
    name: "Select Board FY27 Goals and Objectives",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/59604",
    authorizingBody: "Select Board",
    dateAdopted: "2025-09-16",
    tags: [{label: "Type", value: "Plan"}, {label: "Authorizing Body", value: "Select Board"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "select-board-signature-stamps-use-policy",
    name: "Select Board Signature Stamps Use Policy",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/13565/files/attachment/8729",
    authorizingBody: "Select Board",
    dateAdopted: "2025-10-14",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Select Board Office"}],
    notes: "",
  },
  {
    id: "select-board-appointed-public-bodies-handbook",
    name: "Select Board-Appointed Public Bodies Handbook",
    websiteUrl: "https://www.brooklinema.gov/165/Boards-and-Commissions",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/58591/Select-Board-Appointed-Public-Bodies-Handbook-Orientation-August-2025",
    authorizingBody: "Select Board",
    dateAdopted: "2025-10-21",
    tags: [{label: "Type", value: "Handbook"}, {label: "Department", value: "Select Board Office"}, {label: "Public Body", value: "Bicycle Advisory Committee"}, {label: "Public Body", value: "Economic Development Advisory Board"}, {label: "Public Body", value: "Park & Recreation Commission"}, {label: "Public Body", value: "Pedestrian Advisory Committee"}, {label: "Public Body", value: "Solid Waste Advisory Committee"}, {label: "Public Body", value: "Transportation Board"}, {label: "Public Body", value: "Trustees of Walnut Hills Cemetery"}, {label: "Public Body", value: "Zero Emissions Advisory Board"}, {label: "Public Body", value: "Brookline Commission on Disability"}, {label: "Public Body", value: "Commission for Diversity, Equity, Inclusion & Community Relations"}, {label: "Public Body", value: "Housing Advisory Board"}, {label: "Public Body", value: "Planning Board"}],
    notes: "Version 2.0",
  },
  {
    id: "sidewalk-ramp-construction-replacement-and-maintenance-policy",
    name: "Sidewalk/Ramp Construction, Replacement and Maintenance Policy",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/13536/files/attachment/4578",
    authorizingBody: "Select Board",
    dateAdopted: "2025-03-25",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "single-use-plastics-bylaw",
    name: "Single-Use Plastics By-law",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/40472",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}, {label: "Article", value: "8.40A", url: "https://ecode360.com/41144645"}],
    notes: "",
  },
  {
    id: "snow-policy",
    name: "Snow Policy - Senior Center",
    websiteUrl: "https://www.brooklinema.gov/2362/Policies",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Council on Aging"}],
    notes: "",
  },
  {
    id: "social-media-policy",
    name: "Social Media Policy",
    websiteUrl: "https://www.brooklinema.gov/297/Other-Policies-By-Laws#tabc9ae9434-9ad4-4455-b3f8-093b453a85f5_2",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/20371/Social-Media-Policy",
    authorizingBody: null,
    dateAdopted: "2025-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "solicitation-policy",
    name: "Solicitation Policy - Senior Center",
    websiteUrl: "https://www.brooklinema.gov/2362/Policies",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/33650/Solicition-Policy",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Council on Aging"}],
    notes: "",
  },
  {
    id: "solid-waste-regulations",
    name: "Solid Waste Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1081/Solid-Waste-Regulations-PDF",
    authorizingBody: null,
    dateAdopted: "2023-10-24",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Public Body", value: "Solid Waste Advisory Committee"}],
    notes: "",
  },
  {
    id: "strategic-asset-plan-and-major-parcel-study",
    name: "Strategic Asset Plan and Major Parcel Study",
    websiteUrl: "https://www.brooklinema.gov/1313/Strategic-Asset-Plan-Major-Parcel-Study",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2018",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Planning"}],
    notes: "",
  },
  {
    id: "sustainable-bags-bylaw",
    name: "Sustainable Bags By-law",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/47513",
    authorizingBody: null,
    dateAdopted: "2017-07-01",
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}, {label: "Article", value: "8.33", url: "https://ecode360.com/41144084"}],
    notes: "",
  },
  {
    id: "sustainable-containers-and-packaging-bylaw",
    name: "Sustainable Containers and Packaging By-law",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/40473",
    authorizingBody: null,
    dateAdopted: "2020-01-01",
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}, {label: "Article", value: "8.32", url: "https://ecode360.com/41145138"}],
    notes: "",
  },
  {
    id: "swimming-pools-regulations",
    name: "Swimming Pools Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1079",
    authorizingBody: null,
    dateAdopted: "1998-02-20",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "tanning-salons-regulations",
    name: "Tanning Salons Regulations",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1080",
    authorizingBody: null,
    dateAdopted: "1994-04-01",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}],
    notes: "",
  },
  {
    id: "tobacco-bylaw",
    name: "Tobacco By-law",
    websiteUrl: "https://www.brooklinema.gov/507/Sanitary-Codes-Regulations-Town-Bylaws",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/18677/Town-of-Brookline-Tobacco-Bylaw",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Public Health"}, {label: "Division", value: "Environmental Health"}, {label: "Article", value: "8.23", url: "https://ecode360.com/41144679"}],
    notes: "",
  },
  {
    id: "town-legal-notice-policy",
    name: "Town Legal Notice and Web Accessibility Statement",
    websiteUrl: "https://www.brooklinema.gov/586/Town-Legal-Notice-Web-Accessibility-Stat",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Diversity, Equity, Inclusion and Community Relations"}],
    notes: "",
  },
  {
    id: "town-meeting-handbook",
    name: "Town Meeting Handbook",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/53109/TMM-Handbook-Nov-2024-Final?bidId=",
    authorizingBody: null,
    dateAdopted: "2024-11",
    tags: [{label: "Type", value: "Handbook"}, {label: "Department", value: "Town Meeting"}],
    notes: "",
  },
  {
    id: "town-of-brookline-code-of-conduct",
    name: "Town of Brookline Code of Conduct",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62939/Code-of-Conduct-for-Town-of-Brookline",
    authorizingBody: "Select Board",
    dateAdopted: "2022-12-20",
    tags: [{label: "Type", value: "Policy"}],
    notes: "",
  },
  {
    id: "town-owned-outdoor-athletic-field-and-court-use-allocation",
    name: "Town-Owned Outdoor Athletic Field And Court Use Allocation",
    websiteUrl: "https://www.brooklinerec.com/186/Policies#tabc82c7e16-c5b7-4214-b7d8-dc39c1661ff9_0",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Recreation"}, {label: "Public Body", value: "Park & Recreation Commission"}],
    notes: "",
  },
  {
    id: "traffic-calming-and-safety-program-and-policy",
    name: "Traffic Calming and Safety Program and Policy",
    websiteUrl: "https://www.brooklinema.gov/360/Traffic-Calming-Roadway-Safety",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/62017",
    authorizingBody: "Transportation Board",
    dateAdopted: "2024-10-27",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-i-definitions",
    name: "Traffic Rules and Regulations - Article I - Definitions",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/529/ARTICLE-I---Definitions-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-ii-authority-and-duties-of-police",
    name: "Traffic Rules and Regulations - Article II - Authority and Duties of Police",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/530/ARTICLE-II---Authority-and-Duties-of-Police-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-iii-traffic-signs-signals-markings-zones-and-parking-meters",
    name: "Traffic Rules and Regulations - Article III - Traffic Signs, Signals, Markings, Zones and Parking Meters",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/531/ARTICLE-III---Traffic-Signs-Signals-Markings-Zones-and-Parking-Meters-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-iv-zones-of-quiet",
    name: "Traffic Rules and Regulations - Article IV - Zones of Quiet",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/532/ARTICLE-IV---Zones-of-Quiet-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-ix-miscellaneous-provisions",
    name: "Traffic Rules and Regulations - Article IX - Miscellaneous Provisions",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/533/ARTICLE-IX---Miscellaneous-Provisions-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-v-stopping-standing-parking",
    name: "Traffic Rules and Regulations - Article V - Stopping, Standing, Parking",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/536/ARTICLE-V---Stopping-Standing-Parking-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-v-section-17-valet-operations",
    name: "Traffic Rules and Regulations - Article V Section 17 - Valet Operations",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/535/ARTICLE-V-Section-17---Valet-Operations-PDF",
    authorizingBody: null,
    dateAdopted: "2007-04-26",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-va-tow-away-zone-regulations",
    name: "Traffic Rules and Regulations - Article V(A) - Tow Away Zone Regulations",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/537/ARTICLE-VA---Tow-Away-Zone-Regulations-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-vb-permit-parking-regulation",
    name: "Traffic Rules and Regulations - Article V(B) - Permit Parking Regulation",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/534/ARTICLE-VB---Permit-Parking-Regulation-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-vi-one-way-streets",
    name: "Traffic Rules and Regulations - Article VI - One Way Streets",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/538/ARTICLE-VI---One-Way-Streets-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-vii-operation-of-vehicles",
    name: "Traffic Rules and Regulations - Article VII - Operation of Vehicles",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/540/ARTICLE-VII---Operation-of-Vehicles-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-viia-pedestrian-control-regulations",
    name: "Traffic Rules and Regulations - Article VII A - Pedestrian Control Regulations",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/539/ARTICLE-VII-A---Pedestrian-Control-Regulations-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-viii-heavy-and-commercial-vehicles-excluded",
    name: "Traffic Rules and Regulations - Article VIII - Heavy and Commercial Vehicles Excluded",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/541/ARTICLE-VIII---Heavy-and-Comercial-Vehicles-Excluded-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-x-responsibility-of-owner",
    name: "Traffic Rules and Regulations - Article X - Responsibility of Owner",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/542/ARTICLE-X---Responsibility-of-Owner-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-xi-penalties",
    name: "Traffic Rules and Regulations - Article XI - Penalties",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/543/ARTICLE-XI---Penalties-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-xii-bicycle-regulations",
    name: "Traffic Rules and Regulations - Article XII - Bicycle Regulations",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/527/ARTICLE-XII---Bicycle-Regulations-PDF",
    authorizingBody: null,
    dateAdopted: "2013-05-16",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}, {label: "Public Body", value: "Bicycle Advisory Committee"}],
    notes: "",
  },
  {
    id: "traffic-rules-and-regulations-article-xiii-operation-of-motor-vehicles-with-respect-to-bicyclists",
    name: "Traffic Rules and Regulations - Article XIII - Operation of Motor Vehicles With Respect to Bicyclists",
    websiteUrl: "https://www.brooklinema.gov/DocumentCenter/Index/111",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/528/ARTICLE-XIII---Operation-of-Motor-Vehicles-With-Respect-to-Bicyclists-PDF",
    authorizingBody: null,
    dateAdopted: null,
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}, {label: "Public Body", value: "Bicycle Advisory Committee"}],
    notes: "",
  },
  {
    id: "transportation-access-plan-guidelines",
    name: "Transportation Access Plan Guidelines",
    websiteUrl: "https://www.brooklinema.gov/2496/Construction-Management-Transportation-A",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/13703/Transportation-Access-Plan-Guidelines-2018-PDF",
    authorizingBody: null,
    dateAdopted: "2018-01",
    tags: [{label: "Type", value: "Guidelines"}, {label: "Department", value: "Public Works"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "transportation-and-mobility-plan",
    name: "Transportation and Mobility Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/29829/Brookline-Transportation--Mobility-Plan-FINAL-02252022",
    authorizingBody: null,
    dateAdopted: "2022-02",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "tree-preservation-by-law-rules-and-regulations",
    name: "Tree Preservation By-law Rules and Regulations",
    websiteUrl: "https://www.brooklinema.gov/3709/Tree-Protection-Removal",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/58577/Tree-Preservation-Bylaw-Rules-and-Regulations?bidId=",
    authorizingBody: null,
    dateAdopted: "2025-03-27",
    tags: [{label: "Type", value: "Regulations"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}],
    notes: "",
  },
  {
    id: "unfunded-liabilities-policy",
    name: "Unfunded Liabilities Policy",
    websiteUrl: null,
    documentUrl: "https://brooklinema.portal.civicclerk.com/event/14919/files/attachment/10535",
    authorizingBody: "Select Board",
    dateAdopted: "2025-09-09",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Finance"}],
    notes: "",
  },
  {
    id: "urban-forest-climate-resiliency-master-plan",
    name: "Urban Forest Climate Resiliency Master Plan",
    websiteUrl: "https://www.brooklinema.gov/1758/Urban-Forest-Climate-Resiliency-Master-P",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/25153/Brookline-Urban-Forest-Climate-Resiliency-Master-Plan-Report-June-2021",
    authorizingBody: null,
    dateAdopted: "2021-06",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}],
    notes: "",
  },
  {
    id: "use-of-town-vehicles-policy",
    name: "Use of Town Vehicles Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8179/Use-of-Town-Vehicles-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2000-08",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "vision-zero-action-plan",
    name: "Vision Zero Action Plan",
    websiteUrl: "https://www.brooklinema.gov/3783/Vision-Zero-Action-Plan",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/57399/Final-Brookline-Vision-Zero-Action-Plan---May-2025_with-appendices?bidId=",
    authorizingBody: null,
    dateAdopted: "2025-04",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}, {label: "Public Body", value: "Bicycle Advisory Committee"}],
    notes: "",
  },
  {
    id: "walkable-streets-priorities-plan",
    name: "Walkable Streets Priorities Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/61989",
    authorizingBody: "Transportation Board",
    dateAdopted: "2023-05-17",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Pedestrian Advisory Committee"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "walnut-hills-cemetery-master-plan",
    name: "Walnut Hills Cemetery Master Plan",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/1156/Walnut-Hills-Cemetery-Master-Plan?bidId=",
    authorizingBody: null,
    dateAdopted: "2004-01",
    tags: [{label: "Type", value: "Plan"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Parks & Open Spaces"}, {label: "Public Body", value: "Trustees of Walnut Hills Cemetery"}],
    notes: "",
  },
  {
    id: "washington-square-parking-and-curb-use-study",
    name: "Washington Square Parking and Curb Use Study",
    websiteUrl: "https://www.brooklinema.gov/3941/Washington-Square-Parking-and-Curb-Use-S",
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/63112",
    authorizingBody: null,
    dateAdopted: "2026-07-28",
    tags: [{label: "Type", value: "Study"}, {label: "Department", value: "Public Works"}, {label: "Division", value: "Engineering & Transportation"}, {label: "Public Body", value: "Transportation Board"}],
    notes: "",
  },
  {
    id: "weather-emergency-policy",
    name: "Weather Emergency Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/8176/Weather-Emergency-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2011-01",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "workplace-safety-policy",
    name: "Workplace Safety Policy",
    websiteUrl: null,
    documentUrl: "https://www.brooklinema.gov/DocumentCenter/View/342/Workplace-Safety-Policy-PDF",
    authorizingBody: null,
    dateAdopted: "2004-02",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "Human Resources"}],
    notes: "",
  },
  {
    id: "written-information-security-policy",
    name: "Written Information Security Policy (WISP)",
    websiteUrl: "https://www.brooklinema.gov/3976/Written-Information-Security-WISP",
    documentUrl: null,
    authorizingBody: null,
    dateAdopted: "2025-08-19",
    tags: [{label: "Type", value: "Policy"}, {label: "Department", value: "IT"}],
    notes: "",
  },
  {
    id: "zoning-by-laws-and-guidelines",
    name: "Zoning By-Laws and Guidelines",
    websiteUrl: "https://www.brooklinema.gov/1479/Zoning-By-Laws-and-Guidelines",
    documentUrl: null,
    authorizingBody: "Town Meeting",
    dateAdopted: null,
    tags: [{label: "Type", value: "By-laws"}, {label: "Department", value: "Town Meeting"}, {label: "Public Body", value: "Planning Board"}],
    notes: "",
  },
];

// Retired ids -> current ids. Ids are permanent, so when one does change, add
// the old id here and the detail page redirects /governing-documents/<old> to
// the new URL. Never remove an entry.
export const governingDocsIdRedirects = {
  "bridle-path-feasibility-study-and-concept-plan": "bridle-path-feasibility-study",
};

export default governingDocsData;
